export const formatToSelect = (response: { items?: Array<any> }) => {
  if (response?.items?.length) {
    return response.items.map(value => ({
      key: value.id,
      text: value.name
    }));
  }
};
